import React from 'react'
import PropTypes from 'prop-types';
import classNames from 'classnames'
import style from './style.css';

export default class WarningPanel extends React.Component {
  
  render() {
    let title = null;
    let subtitle = null;
    let code = null;
    let message = null;

    if ( this.props.code ) {
      code = <div className={style.warningCode}>{this.props.code}</div>
    } 

    if ( this.props.title ) {
      title = <div className={style.warningTitle}>{this.props.title}</div>
    } 
    if ( this.props.subtitle ) {
      subtitle = <div className={style.warningSubtitle}>{this.props.subtitle}</div>
    }

    if ( this.props.message ) {
      message = <div className={style.warningMessage}>{this.props.message}</div>
    }
    const clazz = classNames( style.warningPanel, this.props.className );
    return (
      <div className={clazz}>
        {/* <img src="/assets/images/robot.png" className={style.warningImage}/>*/}
        <div className={style.rest}>
          {code}
          {title}
          {subtitle}
          {message}

          {this.props.children}
        </div>
      </div>
    )
  }
}
